exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-box[data-v-25386887]{position:absolute;top:130%;right:-15px;width:320px;background:#fff}.search-input[data-v-25386887]{padding:10px}.search-button[data-v-25386887]{padding-top:5px;padding-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25386887","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./web/app/themes/giles/resources/js/components/MenuSearch.vue
// module id = 396
// module chunks = 0